import type { ReplaceKind } from '@avs/contract';
import { Field } from '../Field.js';
import { Textarea } from '../Textarea.js';
import { NativeSelect } from '../Toolbar.js';
import { STRATEGIES, KIND_PROMPT_PLACEHOLDER } from '../../utils/kinds.js';
import type { WizardParams } from './types.js';

const RES = [{ value: '720p', label: '720p' }, { value: '1080p', label: '1080p' }, { value: '2K', label: '2K' }] as const;
const DUR = [{ value: '5 秒', label: '5 秒' }, { value: '10 秒', label: '10 秒' }, { value: '15 秒', label: '15 秒' }] as const;
const RETRY = [{ value: '1', label: '1' }, { value: '2', label: '2' }, { value: '3', label: '3' }];

type Props = {
  kind: ReplaceKind;
  params: WizardParams;
  onChange: (p: WizardParams) => void;
};

export function StepParams({ kind, params, onChange }: Props) {
  const strategies = STRATEGIES[kind];
  return (
    <div className="wiz-params">
      <div className="card" style={{ maxWidth: 720, margin: '0 auto' }}>
        <div className="block-title" style={{ marginBottom: 'var(--space-s)' }}>统一生成参数</div>
        <div className="muted small" style={{ marginBottom: 'var(--space-m)' }}>
          这些参数应用到本批次的所有配对任务。
        </div>

        {kind === 'object' && (
          <Field
            label="要替换的物体（真·替换关键）"
            hint="填画面里要换掉的那个东西，系统自动识别它的区域、只换它、其余不动。英文更准，如 treadmill / bottle / sofa。留空则退化为整体重生成（不精准）。"
          >
            <input
              className="input"
              style={{ width: '100%' }}
              placeholder="treadmill"
              value={params.replaceTarget}
              onChange={(e) => onChange({ ...params, replaceTarget: e.target.value })}
            />
          </Field>
        )}

        <Field label="提示词修改策略" hint="完全替换最激进；保留/仅替换类策略会限制变更范围，更稳。">
          <NativeSelect<string>
            value={params.strategy}
            onChange={(v) => onChange({ ...params, strategy: v })}
            options={strategies.map((s) => ({ value: s, label: s }))}
            width="100%"
          />
        </Field>

        <div className="form-2">
          <Field label="分辨率">
            <NativeSelect<typeof params.resolution>
              value={params.resolution}
              onChange={(v) => onChange({ ...params, resolution: v })}
              options={RES} width="100%" />
          </Field>
          <Field label="时长上限">
            <NativeSelect<typeof params.duration>
              value={params.duration}
              onChange={(v) => onChange({ ...params, duration: v })}
              options={DUR} width="100%" />
          </Field>
        </div>

        <Field label="重生成次数">
          <NativeSelect<string>
            value={String(params.retries)}
            onChange={(v) => onChange({ ...params, retries: parseInt(v, 10) })}
            options={RETRY} width="100%" />
        </Field>

        <Field label="替换提示词 Prompt（选填）" hint="留空则用该替换类型的默认提示词。">
          <Textarea
            rows={3}
            placeholder={KIND_PROMPT_PLACEHOLDER[kind]}
            value={params.promptOverride}
            onChange={(e) => onChange({ ...params, promptOverride: e.target.value })}
          />
        </Field>
      </div>
    </div>
  );
}
